import {createAction, props} from "@ngrx/store";
import {FlyingFleet} from "../../models/FlyingFleet";

export const UPDATE = '[FlyingFleets] Update';
export const REFRESH = '[FlyingFleets] Refresh';
export const update = createAction(UPDATE, props<{ flyingFleet: FlyingFleet }>());
export const refresh = createAction(REFRESH);
